(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score.js');
"use strict";


const _svs$components$sport = svs.components.sport.quickplayModal.coupons.CouponScoreParts,
  EventRowHeader = _svs$components$sport.EventRowHeader,
  EventRowOutcomes = _svs$components$sport.EventRowOutcomes;
const CouponScore = _ref => {
  let branding = _ref.branding,
    drawData = _ref.drawData,
    isPixMix = _ref.isPixMix;
  const _ref2 = drawData || {},
    productId = _ref2.productId,
    events = _ref2.events;
  return React.createElement("div", {
    className: "u-flex u-flex-column u-flex-justify-content-between notranslate"
  }, events.map((eventItem, eventIndex) => React.createElement("section", {
    className: "coupon-score-event",
    key: "qp-score-event-".concat(eventItem.captionShort)
  }, React.createElement(EventRowHeader, {
    bradning: branding,
    eventIndex: eventIndex,
    eventItem: eventItem
  }), React.createElement(EventRowOutcomes, {
    eventIndex: eventIndex,
    isPixMix: isPixMix,
    productId: productId
  }))));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponScore', CouponScore);

 })(window);